// Runtime config the server injects into index.html (src/login/spa-index.ts).
//
// Render order is the SPA's; enablement is the server's. A provider is only
// offered when the serving pod reports it configured, so a kill switch or a
// missing credential hides the button instead of bouncing the click with
// provider_not_configured.
//
// No injected config means the page was not served by auth-service. A dev
// build (Vite serves its own index.html) shows every known provider so the
// row can be worked on; a production build renders none, so a broken
// injection is visible on the login page instead of silently offering a
// stale list, which is the failure this file exists to end.

// window.__AUTH_CONFIG__ is declared once, as the full deployment config, in
// ./deployment.ts. Only its `providers` field is read here.
import "./deployment";

// Google leads; Discord sits at the bottom (owner, 10 Oct: "discord at bottom for twoshot").
const PROVIDER_RENDER_ORDER = ["google", "apple", "instagram", "discord"] as const;

export type LoginProvider = typeof PROVIDER_RENDER_ORDER[number];

export function enabledProviders(): LoginProvider[] {
    const enabled = new Set<string>(window.__AUTH_CONFIG__?.providers ?? (import.meta.env.DEV ? PROVIDER_RENDER_ORDER : []));
    return PROVIDER_RENDER_ORDER.filter(p => enabled.has(p));
}

export function providerLabel(provider: string): string {
    return provider[0].toUpperCase() + provider.slice(1);
}
